import { graphqlClient } from "@/api/graphql";
import {
  GroupTherapyClientsQuery,
  useGroupTherapyClientsQuery,
} from "@/graphql/generated";
import { FIVE_MINUTES } from "@/app/_helpers/constants";

interface UseGroupTherapyClientsParams<T extends object> {
  groupId: string | undefined;
  select?: (data: GroupTherapyClientsQuery) => T;
  enabled: boolean;
}

export const useGroupTherapyClients = <T extends {}>({
  groupId,
  select,
  enabled,
}: UseGroupTherapyClientsParams<T>) => {
  return useGroupTherapyClientsQuery(
    graphqlClient,
    { groupId },
    {
      staleTime: FIVE_MINUTES,
      select,
      enabled,
    },
  );
};
